module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAASCAMAAACdBVWvAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAhOAAAITgBRZYxYAAAAEtQTFRFAAAAILr/JbT/KI//J7f/KLf/IID/J7f/KLb/KbX/J7X/KbT/KK3/J7T/KLX/Kbj/ILX/ILb/IbX/KJ//Jrf/Hrf/Jbf/Jrj/JLb/iAu7+wAAABl0Uk5TADDPIN//EL+gkJBwgHBg7zBQH0Bff5+vjw38ozYAAACCSURBVHicddFHEoAgDAXQUBI72PX+J1WIDm34K+DRAgBRhFRQidKoK/gSVtAToqSSiAmxKU3inzanFkO6lHo+a+CNx5jG/xpUIJOmcNspIxWXYphMTC9a17XCtUVKAHNAHaZ9WXg2wOobW1LR7seI1+3ZSxyuInf2eW2QxzR39St9Hvj7BMyqZIHSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/shape-up.png
// module id = 67kh
// module chunks = 1